import { getDocs, orderBy, query } from 'firebase/firestore';
import { Subject } from '../types/subject';
import BaseService from './base-service';

class SubjectsService extends BaseService<Subject> {
  constructor() {
    super('subjects');
  }

  async getAll(): Promise<Subject[]> {
    const q = query(this.collectionRef, orderBy('order'));
    const querySnapshot = await getDocs(q);
    const subjects: Subject[] = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...(doc.data() as Subject),
    }));

    return subjects;
  }
}

const subjectsService = new SubjectsService();
export default subjectsService;
